import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

type DesktopMacIconProps = SvgIconProps & {}

export function DesktopMacIcon(props: DesktopMacIconProps) {
  return (
    <SvgIcon htmlColor="transparent" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.75 15L7 18L6 19H14L13 18L12.25 15M1 11H19M3 15H17C18.1046 15 19 14.1046 19 13V3C19 1.89543 18.1046 1 17 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15Z"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default DesktopMacIcon